import Backbone from 'backbone'
import MarkedField from 'scoreboard/components/marked-field'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import template from 'scoreboard/components/label-form.hbs'
import _ from 'lodash'
import guard from 'scoreboard/components/unsaved/guard'

/**
 * A dialog with a label field, and save and cancel buttons
 */
var LabelForm = Backbone.View.extend({

	className: 'label-form',

	tagName: 'form',

	events: {
		'click .cancel' : 'cancel'
	},

	initialize: function(options) {
		this.options = options || {}
		this._markedFields = []
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this),
			guard: false
		})
		this.formView.on('change', this._change.bind(this))
	},

	_change: function() {
		// potentially update the placeholder in the tree (e.g. "New Report")
		this.trigger('change', formHelper.readFromDom(this.el))
	},

	render: function () {
		var ctx = {title: this.options.title, label: this.model.get('label')}
		this.$el.html(template(ctx))

		//add error tooltip
		this.label = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start()

		return this
	},

	submit: function(e) {
		this.model.set('label', this.label.val())

		return this.model.save(null, {
			success: function() {
				this.formView.primaryButton.done()
				this.formView.primaryButton.once('animation-complete', function() {
					this.trigger('done', this.model)
				}.bind(this))
			}.bind(this),
			error: function(m, res, opts) {
				guard.stopGuarding()
				this.formView.error(res)
			}.bind(this)
		})
	},

	cancel: function() {
		this.trigger('cancel')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.label, this.formView], 'remove')
	}

})

export default LabelForm

LabelForm.__filename__ = 'components/label-form.js'
